import { getPointer } from "libs/schema";
import { PermissionError } from "libs/errors";
import { ActionServerContext } from "../action";

export async function authorizeUserIsMemberOfOrganization(props: {
  organizationId: string;
  context: ActionServerContext;
}) {
  const { organizationId, context } = props;

  const [membership] = await context.environment.loader.getRecord(
    getPointer("organization_user_member", {
      user_id: context.currentUserId,
      organization_id: organizationId,
    }),
  );

  if (!membership) {
    throw new PermissionError("User is not a member of the organization");
  }
}
